"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mainLogger = exports.logDebug = void 0;
var _checkoutUtils = require("@ori/checkout-utils");
var _logger = require("@ori/logger");
var _constants = require("./constants");
/* istanbul ignore file -- loggers */

const mainLogger = exports.mainLogger = new _logger.Logger(_constants.PACKAGE_NAME, {
  teamName: _constants.TEAM_NAME
});
const logDebug = exports.logDebug = (0, _checkoutUtils.getLogger)(_constants.LIBRARY_NAME, _checkoutUtils.LogLevel.Debug, _constants.LOG_COLOR);
